import { useEffect } from "react";

interface Props {
  refs: React.RefObject<HTMLElement | null>[];
  handler: (event: MouseEvent | TouchEvent) => void;
}

export default function useOnClickOutside({ refs, handler }: Props) {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      const isInside = refs.some(
        (ref) => ref.current && ref.current.contains(event.target as Node)
      );
      if (!isInside) {
        handler(event);
      }
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [refs, handler]);
}
